module.exports = __webpack_public_path__ + "img/icon-noMessage.f82c9b93.png";